import z from "zod";
import { requiredBoolean, requiredId, requiredNumber, requiredText } from "../lib/schemas";
export const requirementIdParamSchema = z.object({
    requirementId: requiredId
});
export const getRequirementOutputSchema = z.object({
    id: requiredNumber,
    documentName: requiredText,
    hasTagBase: requiredBoolean
});
export const createRequirementInputSchema = z.object({
    documentId: requiredNumber,
});
